import App from "../../app";
import OverviewSummaryTable from "../../lib/overviewsummary";
import OverviewScoreChart from "../../lib/chart/overviewscore";
import { OverviewScore } from "../../model/datasource/score";
import { SectionFrontend, SummaryFrontend } from "../frontend";
import { SectionView, SummaryView } from "../view";
import { AttemptId, ProductId, ItemId, QuizId } from "../../model/datasource";
import {
	ReviewSectionScoreChart,
	ReviewTotalScoreChart, TestProgressChart
} from "../../lib/chart";
import { ChartView } from "../view/chart";

export class OverviewSectionView<P extends ProductId, A extends AttemptId, Z extends QuizId, I extends ItemId> extends SectionView<P, A, Z, I> {
	constructor(frontend?: SectionFrontend<Z, I>) {
		super(frontend);
	}

	init(app: App<P, A, Z, I>): void {
		const bindTarget = app.view.getBindTarget();
		[
			this.frontend.getBindStart()
		].forEach(bind => bind.bind(bindTarget));
	}

	displayOverviewScores(chart: OverviewScoreChart<A, Z>, scores: OverviewScore<A, Z>[]): void {
		for (const score of scores) {
			const chartElement = this.frontend.getSectionChart(score.quiz);
			if (chartElement) {
				chart.display(chartElement, score.data);
			}
		}
	}

	toggleStart(element: HTMLElement): void {
		this.frontend.toggleStart(element);
	}
}

export class OverviewSummaryView<P extends ProductId, A extends AttemptId, Z extends QuizId, I extends ItemId> extends SummaryView<P, A, Z, I> {
	constructor(frontend?: SummaryFrontend<P>) {
		super(frontend);
	}

	init(app: App<P, A, Z, I>): void {
	}

	displayTable(table: OverviewSummaryTable<P>, product: P): void {
		const element = this.frontend.getTable();
		table.display(element, product);
	}
}

export class OverviewChartView<P extends ProductId, A extends AttemptId, Z extends QuizId, I extends ItemId> extends ChartView<P, A, Z, I> {
	init(app: App<P, A, Z, I>): void { }

	getReviewTotalScoreChart(): ReviewTotalScoreChart {
		throw new Error("Method not implemented.");
	}

	getReviewSectionScoreChart(): ReviewSectionScoreChart {
		throw new Error("Method not implemented.");
	}

	getOverviewScoreChart<A, Z>(): OverviewScoreChart<A, Z> {
		return this.frontend.getOverviewScoreChart();
	}

	getTestProgressChart(): TestProgressChart {
		throw new Error("Method not implemented.");
	}

	getOverviewSummaryTable(jQuery: JQueryStatic): OverviewSummaryTable<P> {
		return this.frontend.getOverviewSummaryTable(jQuery);
	}
}
